const importProductsDictES = {
  importProductsFromCSVFile:
    "Cargue un archivo .csv a continuación para importar productos desde él",
  importTemplateExplanation:
    "SÓLO se importarán los datos básicos, como el título, la descripción, el precio y las imágenes, aún deberá revisar y revisar cada producto resultante y editarlo en consecuencia. Las variantes del producto tampoco se importan y deben configurarse en consecuencia.",
  fringeBenefitDownloadedSuccessfully: "Beneficio complementario descargado exitosamente",
  discharge: "Descargar",
  doYouWantToCancelTheProductBelow: "¿Quieres cancelar el siguiente voucher?",
  wasDischargedFromFringeBenefit: "Fue dado de baja del beneficio complementario",
  associatedVoucher: "Cupón(es) asociado(s)"
};

export default importProductsDictES;
